
const formatPrice = value => {
    const amount = Number(value);
    const options = window.Checkout.settings.price || {};
    const formatter = new Intl.NumberFormat(window.Checkout.settings.locale, {
        style: 'currency',
        currency: options.currency_code,
        ...(options.replace_decimal_separator ? { minimumFractionDigits: options.round_decimals } : null),
    });
    const formattedParts = formatter.formatToParts(amount);
    let formattedPrice;
    const prefix = options.currency_prefix || '';
    const suffix = options.currency_suffix || '';
    for (const part of formattedParts) {
        // We will handle currency ourselves from the settings
        if (part.type === 'currency' || part.type === 'literal') {
            part.value = '';
        }
        if (part.type === 'group' && options.hide_group_seperator) {
            part.value = '';
        }
        if (part.type === 'group' && options.replace_group_seperator) {
            part.value = options.replace_group_seperator;
        }
        if (part.type === 'decimal') {
            if (options.replace_decimal_separator) {
                part.value = options.replace_decimal_separator;
            }
            if ((options.hide_decimal_zeros && amount % 1 === 0) || options.hide_decimal_fractions) {
                part.value = '';
            }
        }
        if (part.type === 'fraction') {
            if (options.round_decimals) {
                part.value = Number('0.' + part.value)
                    .toFixed(options.round_decimals)
                    .toString()
                    .slice(2);
            }
            if (amount % 1 === 0) {
                if (options.replace_round_number_decimals) {
                    part.value = options.replace_round_number_decimals;
                }
                if (options.hide_decimal_zeros) {
                    part.value = '';
                }
            }
            if (options.hide_decimal_fractions) {
                part.value = '';
            }
        }
    }

    formattedPrice = formattedParts.map(e => e.value).join('');
    formattedPrice = prefix + formattedPrice + suffix;

    return formattedPrice;
};


export {
    formatPrice,
};
